var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mask" }, [
    _c(
      "div",
      {
        ref: "dialogRef",
        staticClass: "dialog",
        attrs: {
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": _vm.titleId,
          tabindex: "-1",
        },
        on: { keydown: _vm.onKeydown },
      },
      [
        _c("header", { staticClass: "dialog__header" }, [
          _c(
            "h2",
            { staticClass: "dialog__title", attrs: { id: _vm.titleId } },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("proofreadingPendingWorkDialog.title")) +
                  " "
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "dialog__body" }, [
          _c("p", { staticClass: "dialog__message" }, [
            _vm._v(_vm._s(_vm.$t("proofreadingPendingWorkDialog.message"))),
          ]),
        ]),
        _c("footer", { staticClass: "dialog__footer" }, [
          _c(
            "button",
            {
              staticClass: "dialog__yes-button",
              attrs: { type: "button" },
              on: { click: _vm.onClickYes },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("proofreadingPendingWorkDialog.yes")) + " "
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "dialog__no-button",
              attrs: { type: "button" },
              on: { click: _vm.onClickNo },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("proofreadingPendingWorkDialog.no")) + " "
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }